// removed by extract-text-webpack-plugin
module.exports = {"BodyText":"_2Cr6V4XbXqFfA6NZ-OYFiq","ProfileMetaText":"iufGNgj48M1bB1THQN6Nh","BackLink":"_300quIMwMxmT74kpT2-Xvj","Title":"v3hiEyCUImRYo4TCNJiyF","Container":"_2_AO9tdhCLX0KK1u9fFDIJ","CompanyName":"_3xWMUYjcezPE4Ek32R6X63","HeaderTitle":"_3P6L1myY9Ei_ASesqmG5eI","ArticlePage":"_1RqmtyFGs2QIN3wKMQKuc6","Header":"_1oDmP46nmAgdGJAn8uN4to","ArticleContainer":"_116j4rrSjqk2zt_FnVtLUU","ProfilePicture":"_3TuD_GYWCVwvlqyVXWN8QD","ArticleTextContainer":"_2FztZCHe_Afti0RCShf5KX"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Preview/ClientChat/HelpDeskItem/style.css
// module id = 1859
// module chunks = 0